module.exports = "img/flags/HU.145d10a.png";